import { render, staticRenderFns } from "./cust-card.vue?vue&type=template&id=2bcdacee&scoped=true&"
import script from "./cust-card.vue?vue&type=script&lang=js&"
export * from "./cust-card.vue?vue&type=script&lang=js&"
import style0 from "./cust-card.vue?vue&type=style&index=0&id=2bcdacee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcdacee",
  null
  
)

export default component.exports